<template>
  <div class="dj-login">
    <!-- ================= HERO (ambient video) ================= -->
    <section class="dj-login__hero">
      <video
        class="dj-login__video"
        autoplay
        muted
        loop
        playsinline
        poster=""
      >
        <source src="/videos/login-bg.mp4" type="video/mp4" />
      </video>
      <div class="dj-login__scrim"></div>

      <div class="dj-login__hero-content">
        <div class="dj-login__brand">
          <v-img
            :src="require('../../assets/logo.png')"
            max-width="46"
            contain
            class="dj-login__logo"
          ></v-img>
          <div>
            <div class="dj-login__brand-name">DJ</div>
            <div class="dj-login__brand-sub">Daily Jobs · Marine Suite</div>
          </div>
        </div>

        <div class="dj-login__hero-copy">
          <h1 class="dj-login__headline">
            Precision costing for<br />every vessel.
          </h1>
          <p class="dj-login__lede">
            Plan jobs, build quotations, and track project costs from dry-dock
            to delivery, all in one workspace.
          </p>
          <div class="dj-login__meta">
            <span class="dj-login__dot"></span>
            Trusted for project &amp; quotation management
          </div>
        </div>
      </div>
    </section>

    <!-- ================= FORM ================= -->
    <section class="dj-login__panel">
      <div class="dj-login__form">
        <v-img
          :src="require('../../assets/logo.png')"
          max-width="52"
          contain
          class="dj-login__form-logo"
        ></v-img>

        <p class="dj-login__eyebrow">Welcome back</p>
        <h2 class="dj-login__title">Sign in to DJ</h2>
        <p class="dj-login__subtitle">
          Enter your credentials to access your workspace.
        </p>

        <v-text-field
          v-model="form.email"
          outlined
          label="Email"
          prepend-inner-icon="mdi-email-outline"
          :error-messages="errors.email"
          class="dj-login__field"
          hide-details="auto"
        ></v-text-field>

        <v-text-field
          v-model="form.password"
          type="password"
          outlined
          label="Password"
          prepend-inner-icon="mdi-lock-outline"
          :error-messages="errors.password"
          class="dj-login__field"
          hide-details="auto"
          @keyup.enter="login"
        ></v-text-field>

        <v-btn
          block
          large
          color="primary"
          class="dj-login__submit"
          :loading="isLoading"
          @click="login"
        >
          Sign in
          <v-icon right small>mdi-arrow-right</v-icon>
        </v-btn>

        <p class="dj-login__footnote">
          Protected workspace · Contact your administrator for access
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      isLoading: false,
    };
  },
  mounted() {
    if (this.$route.query.isSupplier) {
      this.form.email = "supplier@anonymous.com";
      this.form.template_id = this.$route.query.template_id;
      this.form.supplier_id = this.$route.query.supplier_id;
      let url =
        "create_quotation?template_id=" +
        this.$route.query.template_id +
        "&supplier_id=" +
        this.$route.query.supplier_id;
      this.form.url = url;
      this.form.isSupplier = true;
      this.login();
    }
  },
  methods: {
    ...mapActions({
      logIn: "auth/logIn",
    }),
    async login() {
      this.isLoading = true;
      var _this = this;
      this.logIn(this.form)
        .then((response) => {
          if (_this.form.isSupplier) {
            console.log("supplier");
            _this.$router.push(
              `/modules/tree?type=GENERAL&project_id=${response.data.quotationId}&logged_in=supplier`
            );
          } else {
            console.log("dashboard");
            location.reload("/dashboards");
          }
          //
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.dj-login {
  display: grid;
  grid-template-columns: 1.15fr 1fr;
  min-height: 100vh;
  width: 100%;
  background: var(--dj-bg);
}

/* ---------- Hero ---------- */
.dj-login__hero {
  position: relative;
  overflow: hidden;
  display: flex;
  isolation: isolate;
}
.dj-login__video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -2;
}
.dj-login__scrim {
  position: absolute;
  inset: 0;
  z-index: -1;
  background: linear-gradient(
      205deg,
      oklch(0.26 0.032 196 / 0.55) 0%,
      oklch(0.2 0.03 197 / 0.74) 55%,
      oklch(0.16 0.028 198 / 0.94) 100%
    ),
    radial-gradient(
      120% 90% at 82% 4%,
      oklch(0.635 0.108 66 / 0.28) 0%,
      transparent 58%
    );
}
.dj-login__hero-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 44px 56px;
  width: 100%;
  color: #fff;
}
.dj-login__brand {
  display: flex;
  align-items: center;
  gap: 14px;
}
.dj-login__logo {
  background: oklch(1 0 0 / 0.94);
  border-radius: 12px;
  padding: 7px;
  box-shadow: 0 6px 18px oklch(0 0 0 / 0.28);
}
.dj-login__brand-name {
  font-family: var(--dj-display);
  font-size: 1.45rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 1;
}
.dj-login__brand-sub {
  font-family: var(--dj-mono);
  font-size: 0.68rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--dj-brass-bright);
  margin-top: 4px;
}
.dj-login__headline {
  font-family: var(--dj-display);
  font-size: clamp(2.1rem, 3.4vw, 3rem);
  font-weight: 700;
  line-height: 1.06;
  letter-spacing: -0.03em;
  margin: 0 0 18px;
  text-shadow: 0 2px 20px oklch(0 0 0 / 0.35);
}
.dj-login__lede {
  font-size: 1.02rem;
  line-height: 1.6;
  max-width: 30rem;
  color: oklch(0.94 0.01 255 / 0.86);
  margin: 0 0 26px;
}
.dj-login__meta {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.82rem;
  letter-spacing: 0.02em;
  color: oklch(0.94 0.01 255 / 0.8);
}
.dj-login__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--dj-brass-bright);
  box-shadow: 0 0 0 4px oklch(0.635 0.12 66 / 0.3);
}

/* ---------- Form panel ---------- */
.dj-login__panel {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background: var(--dj-surface);
}
.dj-login__form {
  width: 100%;
  max-width: 380px;
}
.dj-login__form-logo {
  display: none;
  margin-bottom: 20px;
}
.dj-login__eyebrow {
  font-family: var(--dj-mono);
  font-size: 0.72rem;
  font-weight: 500;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--dj-brass-strong);
  margin: 0 0 8px;
}
.dj-login__title {
  font-family: var(--dj-display);
  font-size: 1.85rem;
  font-weight: 700;
  letter-spacing: -0.025em;
  color: var(--dj-text);
  margin: 0 0 8px;
  line-height: 1.1;
}
.dj-login__subtitle {
  font-size: 0.95rem;
  color: var(--dj-text-soft);
  margin: 0 0 30px;
}
.dj-login__field {
  margin-bottom: 18px;
}
.dj-login__submit {
  margin-top: 6px;
  height: 50px !important;
  font-size: 1rem !important;
  border-radius: var(--dj-radius-sm) !important;
  box-shadow: 0 8px 22px -8px var(--dj-accent-ring) !important;
}
.dj-login__footnote {
  margin-top: 22px;
  font-size: 0.78rem;
  color: var(--dj-text-faint);
  text-align: center;
}

/* ---------- Responsive ---------- */
@media (max-width: 960px) {
  .dj-login {
    grid-template-columns: 1fr;
  }
  .dj-login__hero {
    display: none;
  }
  .dj-login__form-logo {
    display: block;
  }
  .dj-login__panel {
    min-height: 100vh;
  }
}
</style>
